import React from "react";
import { Link } from "react-router-dom";
import "./Vehicle.css";

const Vehicle = (props) => {
  const { id, name, image } = props.vehicle;
  return (
    <div className="col-md-3 col-sm-12 vehicle-card">
      <Link to={`/destination/${id}`}>
        <div className="d-flex justify-content-center mt-5">
          <img width="150px" src={image} alt="" />
        </div>

        <h3 className="mt-5 text-center">{name}</h3>
      </Link>
    </div>
  );
};

export default Vehicle;
